export const AutoCompleteConfig = {
  CIRCULAR_PROGRESS_SIZE: 20,
  NO_OPTION_TEXT: 'Nada foi encontrado',
  LOADING_TEXT: 'Buscando...',
  PAGINATION_SIZE: 20,
};
